import type { MainNavRoute, MainPath } from '../types';

import PERMISSIONS from '@snowit/utilities/permissions';

export const QuickSearchPath: MainPath = '/quick_search';
export const QuickSearchCardPath: MainPath = '/quick_search_card';
export const QuickSearchMembershipPath: MainPath = '/quick_search_membership';

export const QuickSearchRoute: MainNavRoute = {
  path: '/quick_search',
  label: 'quick_search',
  permissions: [PERMISSIONS.QUICK_SEARCH__ALL],
  icon: 'search_fast',
  type: 1,
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-24061/a18e02a9124862a',
};

export const QuickSearchCardRoute: MainNavRoute = {
  path: '/quick_search_card',
  label: 'quick_search_card',
  permissions: [
    PERMISSIONS.QUICK_SEARCH__CARD,
    PERMISSIONS.QUICK_SEARCH__MEMBERSHIP,
    PERMISSIONS.QUICK_SEARCH__TRANSITS,
  ],
  logic: 'OR',
  icon: 'search_snowitcard',
  type: 1,
  kb: 'https://doc.clickup.com/20614177/p/h/kn311-24061/a18e02a9124862a',
};

export const QuickSearchMembershipRoute: MainNavRoute = {
  path: '/quick_search_membership',
  label: 'quick_search_membership',
  permissions: [PERMISSIONS.QUICK_SEARCH__MEMBERSHIPS_ONLY],
  // logic: 'OR',
  icon: 'memberships_3',
  type: 1,
  // kb: 'https://doc.clickup.com/20614177/p/h/kn311-24061/a18e02a9124862a',
};
